import {
    TicketType,
    TicketStatus,
    EventType,
    EventStatus,
} from './enums';
import IActiveTicket from '@core/mappers/tickets/dtos/IActiveTicketDto';

export type ActiveTicket = IActiveTicket;
interface Payment {
    total: number;
    stake: number;
    handlingFee: number;
    tax: number;
    branchId: string;
}

export interface Win {
    minPotential: number;
    estimated: number;
    bonus?: number;
    bonusPercent?: number;
    payoff: number;
    tax: number;
    branchId: null | string;
}

interface Odd {
    coefficient: number;
    isFix: boolean | null; // TODO
    systemGroupName: string | null;
    name: string;
    specialValue: null | string;
    oddId: string;
    oddUuid: string;
    marketName: string;
}

export interface EventCondensed {
    IsSpecialFromSportOffer: boolean;
    tournamentName: string;
    date?: Date; /* TODO it's not optional AbstractMapper.toDate needs
    to have a signature string => date | null => undefined */
    eventId: string;
    name: string;
    type: EventType;
    status: EventStatus;
    market: Market;
    marketing: string;
    inputCode: {
        event: string;
        market: string;
    };
    externalIds: {
        betradar?: string;
    } | null;
    odd: Odd;
    eventNo?: string;
    teamNameOne: string;
    teamNameTwo?: string;
}

interface Market {
    marketId: string;
    name: string;
}

interface System {
    selected: number[];
    fixed: number;
    count: number;
}

interface Bonus {
    percentage: number | null;
    value: number;
}

export interface PotentialBonuses  {
    LUCKY_LOSER: boolean;
    SUPER_BONUS: boolean;
}

export default interface Ticket {
    id: string;
    controlCode?: string;
    type: TicketType;
    status: TicketStatus;
    coefficient: number;
    system: System | null; // TODO see what it looks like
    dateReceived: Date;
    datePayoff: Date | null;
    dateLastModified: Date;
    payment: Payment;
    bonus: Bonus | null; // TODO
    win: Win;
    stake?: number;
    potentialBonuses: PotentialBonuses;
    events: EventCondensed[]; // Todo name clear?
}

export class TicketService {
    public static isActive(ticket: Ticket): boolean {
        return ticket.status === TicketStatus.active;
    }

    public static isResolved(ticket: Ticket) {
        return ticket.status !== TicketStatus.active;
    }

    public static getStake(ticket: Ticket): number {
        return ticket.payment.stake;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/tickets/Ticket.ts